var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancialInsightsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1032_393)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.76068 9.16672H9.09997V19.7223H4.76068V9.16672ZM11.5107 0.277832H15.85V19.7223H11.5107V0.277832ZM17.7785 14.1667H22.1178V19.7223H17.7785V14.1667Z",
    stroke: "#101828"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.482117 17.2023C1.38469 16.4967 3.71199 14.4445 6.93029 14.4445C10.1486 14.4445 13.9233 17.2023 17.5374 17.2023C21.1511 17.2023 23.0662 16.3612 26.3201 13.1812",
    stroke: "#101828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1032_393"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialInsightsIcon);
export default __webpack_public_path__ + "static/media/financial-insights-icon.646b36c82638045af45e43b5925558cb.svg";
export { ForwardRef as ReactComponent };